import { CorpusId, WidgetId, WidgetStateId } from './aliases';
import { Paper } from './result-set';

// ------------------- //
// Server Widget State //
// ------------------- //

// defined facet names shown in the facet panel
// and used to determine the order of the facets
export const facetNames = [
  'relevance',
  'criteria',
  'year',
  'venue',
  'author',
] as const;
export type FacetName = (typeof facetNames)[number];

export interface PaperFilter {
  categoryName: FacetName;
  value: string;
}

export const orderByOptions = ['year', 'title', 'venue', 'citation'] as const;
export type OrderBy = (typeof orderByOptions)[number];

export interface Order {
  by: OrderBy;
  isDescending: boolean;
}

export interface RoundInProgress {
  kind: 'in_progress';
}

export interface RoundCompleted {
  kind: 'completed';
}

export interface RoundFailed {
  kind: 'failed';
  error: string;
}

export interface RoundAwaitingClarification {
  kind: 'awaiting_clarification';
  question: string;
}

export type RoundStatus =
  | RoundInProgress
  | RoundCompleted
  | RoundFailed
  | RoundAwaitingClarification;

export interface WidgetState {
  selectedPapers: Array<CorpusId>;
  filters: Array<PaperFilter>;
  currentPage: number;
  pageSize: number;
  ordering: Order | null;
  isLocked: boolean;
  roundStatus: RoundStatus;
}

// ------------------- //
// Client Widget State //
// ------------------- //

export interface SyncStatusOk {
  type: 'ok';
}

export interface SyncStatusReconnecting {
  type: 'reconnecting';
}

export interface SyncStatusError {
  type: 'error';
  errors: Array<string>;
}

export type SyncStatus =
  | SyncStatusOk
  | SyncStatusReconnecting
  | SyncStatusError;

export interface WidgetClientState {
  stateId: WidgetStateId;
  roundStatus: RoundStatus;
  widgetId: WidgetId;
  papers: Array<Paper>;
  selectedPapers: Array<CorpusId>;
  filters: Array<PaperFilter>;
  ordering: Order | null;
  isLocked: boolean;
  pageSize: number;
  currentPage: number;
  query: string;
  syncStatus: SyncStatus;
  numPages: number;
  originalOrderedPapers: Array<Paper>;
  indexOfFirstPaperInPage: number;
  indexOfLastPaperInPage: number;
  prevStateId?: WidgetStateId;
  nextStateId?: WidgetStateId;
}
